import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

interface Props {
    id: string;
    name: string;
    description: string;
    image?: string;
}

const CategoryCard = (props: Props) => {
    const { id, name, description, image } = props;
    const history = useHistory();

    return (
        <Card variant='outlined' style={{display: 'flex', flexDirection: 'column', flex: '1', margin: '8px', minWidth: '300px'}}>
            <CardContent style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                {image && (
                    <div style={{margin: '0 auto 12px', height: '220px', width: '100%', maxWidth: '200px'}}>
                        <img src={image} alt='course' style={{width: '100%', display: 'block'}}/>
                    </div>
                )}
                <div>
                    <Typography variant='h5' component='h2' style={{marginBottom: '4px'}}>
                        {name}
                    </Typography>
                    <Typography variant='body2' component='p'>
                        {description}
                    </Typography>
                </div>
            </CardContent>
            <CardActions>
                <Button style={{margin: '0 auto'}} color='primary' onClick={() => history.push('/courses/' + id)}>Iscriviti</Button>
            </CardActions>
        </Card>
    );
};

export default CategoryCard;
